module.exports = __webpack_public_path__ + "img/69.4efa68fd.jpg";